import { API_SITE_CORPO } from "../api_endpoint";
import { httpwithtoken } from '../http';
 

export const getAllUsers = async ( ) => {  
	try {
		let x=API_SITE_CORPO.USER 
		let { data } = await httpwithtoken.get(x); 
		
		return data.data;
	} catch (error) {
		console.error(error); 
		 
	}
};
 
export const saveuser = async (object:any ) => {  
	try {
		let x=API_SITE_CORPO.USER 
		let { data } = await httpwithtoken.post(x,object); 
		
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};

export const edituser = async (object:any ) => {  
	try {
		let x=API_SITE_CORPO.USER +"/"+object._id
		let { data } = await httpwithtoken.put(x,object); 
		
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};
 
 